import React from 'react';
import styled from 'styled-components';

const StyledContainer = styled.div`
  width: 100%;
  max-width: ${({ $maxWidth, theme }) => {
    if ($maxWidth) return $maxWidth;
    return theme.container.xl;
  }};
  
  margin: 0 auto;
  
  padding: ${({ $padding, theme }) => {
    if ($padding === 'none') return '0';
    if ($padding === 'small') return `0 ${theme.spacing[4]}`;
    if ($padding === 'large') return `0 ${theme.spacing[8]}`;
    return `0 ${theme.spacing[6]}`;
  }};
  
  ${({ $fluid }) => $fluid && `
    max-width: 100%;
    padding: 0;
  `}
  
  ${({ $centered }) => $centered && `
    text-align: center;
  `}
  
  @media (min-width: 576px) {
    padding: ${({ $padding, theme }) => {
      if ($padding === 'none') return '0';
      if ($padding === 'small') return `0 ${theme.spacing[6]}`;
      if ($padding === 'large') return `0 ${theme.spacing[12]}`;
      return `0 ${theme.spacing[8]}`;
    }};
  }
  
  @media (min-width: 768px) {
    padding: ${({ $padding, theme }) => {
      if ($padding === 'none') return '0';
      if ($padding === 'small') return `0 ${theme.spacing[8]}`;
      if ($padding === 'large') return `0 ${theme.spacing[16]}`;
      return `0 ${theme.spacing[10]}`;
    }};
  }
`;

const Container = React.forwardRef(
  ({ children, maxWidth, padding, fluid = false, centered = false, ...props }, ref) => {
    return (
      <StyledContainer
        ref={ref}
        $maxWidth={maxWidth}
        $padding={padding}
        $fluid={fluid}
        $centered={centered}
        {...props}
      >
        {children}
      </StyledContainer>
    );
  }
);

Container.displayName = 'Container';

export default Container;